// Shared chrome for EVERY inline contextual menu — the per-layer floating toolbar on the
// canvas, the section action menus (Copy / Ask Taka), and the timeline quick menu all speak
// the same language: a dark T3 pill (rounded-xl, bg, border-line, card shadow) with
// icon-first buttons. One source of truth so tapping anything anywhere yields the same menu.
// (Historically these were a light "glossy" pill; unified onto T3 dark 2026-07-03.)

export const GLOSSY_PILL = 'rounded-xl border border-line bg-bg shadow-[var(--shadow-card)]'

/** Icon + label button (size/padding set by the caller). */
export const GLOSSY_TEXT_BTN =
  'flex items-center gap-1 rounded-lg text-paper-dim transition-colors hover:bg-bg-3 hover:text-paper'

/** Thin vertical separator (height set by the caller, e.g. `h-4`). */
export const GLOSSY_DIVIDER = 'mx-0.5 w-px bg-line'
